import axios from 'axios';
import { forEachObjIndexed, has } from 'ramda';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.response.use(
    response => response.data,
    error => Promise.reject(error.response.data)
);

export default function (Vue) {
    Vue.groovie = {
        post(uri, data, json = true) {
            let form = data;
            const configs = {
                withCredentials: true,
                headers: {
                    'Content-type': 'application/json'
                }
            };

            if (!json) {
                configs.headers = {};

                form = new FormData();
                const isArray = has('isArray');
                forEachObjIndexed((value, key) => {
                    if (isArray(value)) {
                        forEachObjIndexed((_value, _key) => {
                            if (_key !== 'isArray') {
                                form.append(`${key}[${_key}]`, _value);
                            }
                        }, value);
                    } else {
                        form.append(key, value);
                    }
                }, data);
            }

            return axios.post(uri, form, configs);
        },
        get(uri, params = {}) {
            const configs = {
                withCredentials: true,
                headers: {
                    'Content-type': 'application/json'
                },
                params
            };

            return axios.get(uri, configs);
        },
        put(uri, data, json = true) {
            let form = data;
            const configs = {
                withCredentials: true,
                headers: {
                    'Content-type': 'application/vnd.api+json'
                }
            };

            if (!json) {
                configs.headers = {};

                form = new FormData();
                const isArray = has('isArray');
                forEachObjIndexed((value, key) => {
                    if (isArray(value)) {
                        forEachObjIndexed((_value, _key) => {
                            if (_key !== 'isArray') {
                                form.append(`${key}[${_key}]`, _value);
                            }
                        }, value);
                    } else {
                        form.append(key, value);
                    }
                }, data);
            }

            return axios.put(uri, form, configs);
        },
        delete(url) {
            const configs = {
                withCredentials: true,
                headers: {
                    'Content-type': 'application/json'
                }
            };

            return axios.delete(url, configs);
        },
        token(token) {
            axios.defaults.headers.common.Authorization = `Bearer ${token}`;
        }
    };

    Object.defineProperties(Vue.prototype, {
        $groovie: {
            get: () => Vue.groovie
        }
    });
}



// WEBPACK FOOTER //
// ./src/settings/Api.js